import React, { useState } from "react";
import "./technology.css";

//Mobile images
import mobile1 from "../../assets/images/Technology/Mobile/ios-technologies.png";
import mobile2 from "../../assets/images/Technology/Mobile/android-technologies.png";
import mobile3 from "../../assets/images/Technology/Mobile/flutter.png";
import mobile4 from "../../assets/images/Technology/Mobile/ionic.png";
import mobile5 from "../../assets/images/Technology/Mobile/swift.png";
import mobile6 from "../../assets/images/Technology/Mobile/kotlin.png";

//Frontend images
import front1 from "../../assets/images/Technology/Frontend/angular.png";
import front2 from "../../assets/images/Technology/Frontend/react-native.png";
import front3 from "../../assets/images/Technology/Frontend/html5.png";

//Dtabase images
import database1 from "../../assets/images/Technology/Database/mongodb.png";
import database2 from "../../assets/images/Technology/Database/mysql.png";
import database3 from "../../assets/images/Technology/Database/ms-sql.png";
import database4 from "../../assets/images/Technology/Database/firebase.png";
import database5 from "../../assets/images/Technology/Database/dynamodb.png";
import database6 from "../../assets/images/Technology/Database/redis.png";

//Backend images
import back1 from "../../assets/images/Technology/Backend/php.png";
import back2 from "../../assets/images/Technology/Backend/java-technologies.png";
import back3 from "../../assets/images/Technology/Backend/node.png";

//Cms images
import cms1 from "../../assets/images/Technology/Cms/wordpress.png";
import cms2 from "../../assets/images/Technology/Cms/woocommerce-icon-img.png";
import cms3 from "../../assets/images/Technology/Cms/magento.png";
import cms4 from "../../assets/images/Technology/Cms/shopify.png";

//Infra and Devops images
import infra1 from "../../assets/images/Technology/Infra and Devops/aws.png";
import infra2 from "../../assets/images/Technology/Infra and Devops/gradle.png";
import infra3 from "../../assets/images/Technology/Infra and Devops/svgviewer-png-output-19.png";
import infra4 from "../../assets/images/Technology/Infra and Devops/digital-ocean.png";
import infra5 from "../../assets/images/Technology/Infra and Devops/rackspace.png";

const data = {
  Mobile: [
    { name: "Ios", img: mobile1 },
    { name: "Android", img: mobile2 },
    { name: "Flutter", img: mobile3 },
    { name: "ionic", img: mobile4 },
    { name: "Swift", img: mobile5 },
    { name: "Kotlin", img: mobile6 },
  ],
  Frontend: [
    { name: "Angular js", img: front1 },
    { name: "React js", img: front2 },
    { name: "Html5", img: front3 },
  ],
  Database: [
    { name: "Mongodb", img: database1 },
    { name: "Mysql", img: database2 },
    { name: "Ms sql", img: database3 },
    { name: "Firebase", img: database4 },
    { name: "Dynamodb", img: database5 },
    { name: "Redis", img: database6 },
  ],
  Backend: [
    { name: "Php", img: back1 },
    { name: "Java", img: back2 },
    { name: "Node .js", img: back3 },
  ],
  CMS: [
    { name: "WordPress", img: cms1 },
    { name: "Woocommerce", img: cms2 },
    { name: "Magento", img: cms3 },
    { name: "Shopify", img: cms4 },
  ],
  InfraDevOps: [
    { name: "Aws", img: infra1 },
    { name: "Gradle", img: infra2 },
    { name: "Azure", img: infra3 },
    { name: "Digital ocean", img: infra4 },
    { name: "Rackspace", img: infra5 },
  ],
};

// Create a mapping for display names
const displayNames = {
  Mobile: "Mobile",
  Frontend: "Frontend",
  Database: "Database",
  Backend: "Backend",
  CMS: "CMS",
  InfraDevOps: "Infra and DevOps", // ✅ your desired label
};

const TechCategories = () => {
  // ✅ Default active (Mobile)
  const [active, setActive] = useState("Mobile");

  return (
    <div className="tech-container">
        <h2>Empowering Businesses with Cutting-Edge Technologies</h2>
      <div className="button-row">
        {Object.keys(data).map((key) => (
          <button
            key={key}
            className={`category-btn ${active === key ? "active" : ""}`}
            onMouseEnter={() => setActive(key)} // 👈 change active when hover
          >
            {displayNames[key]}
          </button>
        ))}
      </div>

      <div className="image-wrapper">
        <div className="image-row show">
          {data[active].map((item, index) => (
            <div key={index} className="tech-item">
              <img src={item.img} alt={item.name} />
              <p>{item.name}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default TechCategories;
